import { render, staticRenderFns } from "./consult-edit.vue?vue&type=template&id=5c36f538&scoped=true"
import script from "./consult-edit.vue?vue&type=script&lang=ts"
export * from "./consult-edit.vue?vue&type=script&lang=ts"
import style0 from "./consult-edit.vue?vue&type=style&index=0&id=5c36f538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36f538",
  null
  
)

export default component.exports